import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Compass03 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "compass03",
    className: clsx('stroke-current', className)
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 22c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10Z"
    }), /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14.7221 8.266c.4886-.1629.7328-.2443.8953-.1864a.5001.5001 0 0 1 .303.303c.0579.1625-.0235.4068-.1864.8953l-1.4875 4.4626c-.0464.1392-.0696.2087-.1091.2665a.4991.4991 0 0 1-.1304.1304c-.0578.0395-.1273.0627-.2665.1091L9.2779 15.734c-.4886.1629-.7328.2443-.8953.1864a.5001.5001 0 0 1-.303-.303c-.058-.1625.0235-.4067.1864-.8953l1.4875-4.4626c.0464-.1392.0696-.2087.1091-.2665a.5.5 0 0 1 .1304-.1304c.0578-.0395.1273-.0627.2665-.109l4.4626-1.4876Z"
    })]
  }));
};
export default Compass03;